<template>
  <main class="u-container pb-10">
    <template v-if="!offers.length">
      <AppLoader message="Retrieving offers..." />
    </template>
    <template v-else>
      <div class="text-center">
        <h1 class="text-xl font-bold">
          Your coupons
        </h1>
        <p class="mt-4 text-base">
          Below are the coupons you selected while changing your address on USPS.com.
        </p>
      </div>
      <div class="flex flex-col items-center max-w-600 mx-auto">
        <component
          :is="getTemplate(template.schema.name)"
          v-for="({ accountId, accountName, adGroupId, id, templates: [template] }) in offers"
          :key="id"
          :ad-id="id"
          :ad-group-id="adGroupId"
          :account-id="accountId"
          :account-name="accountName"
          :template-id="template.id"
          :apple-pass="template.properties.applePass"
          :background-url="template.properties.backgroundUrl"
          :background-url-two="template.properties.backgroundUrlTwo"
          :background-url-three="template.properties.backgroundUrlThree"
          :barcode="template.properties.barcode"
          :barcode-two="template.properties.barcodeTwo"
          :barcode-three="template.properties.barcodeThree"
          :cta="template.properties.cta"
          :cta-two="template.properties.ctaTwo"
          :cta-url="template.properties.ctaUrl"
          :cta-pool="template.properties.ctaPool"
          :expiration="template.properties.expiration"
          :fixed="template.properties.fixed"
          :google-pass="template.properties.googlePass"
          :headline="template.properties.headline"
          :headline-two="template.properties.headlineTwo"
          :headline-three="template.properties.headlineThree"
          :legal-text="template.properties.legalText"
          :legal-text-two="template.properties.legalTextTwo"
          :legal-text-three="template.properties.legalTextThree"
          :logo-url="template.properties.logoUrl"
          :logo-url-two="template.properties.logoUrlTwo"
          :logo-url-three="template.properties.logoUrlThree"
          :promo-code="template.properties.promoCode"
          :promo-code-two="template.properties.promoCodeTwo"
          :promo-code-three="template.properties.promoCodeThree"
          :promo-code-label="template.properties.promoCodeLabel"
          :promo-code-label-two="template.properties.promoCodeLabelTwo"
          :promo-code-label-three="template.properties.promoCodeLabelThree"
          :tagline="template.properties.tagline"
          :tagline-two="template.properties.taglineTwo"
          :tagline-three="template.properties.taglineThree"
          class="w-full mt-4"
        />
      </div>
    </template>
  </main>
</template>

<script>
import {
  AdvantageMobileFullPageDefault as AdvantageMobileDefault,
  AdvantageMobileFullPageExpanded as AdvantageMobileExpanded,
} from '@ampersend/mgo';
// from '@mgo/ampersend/lib/components';
import AppLoader from '../components/AppLoader.vue';

export default {
  name: 'SmsReturnToSite',
  components: {
    AdvantageMobileDefault,
    AdvantageMobileExpanded,
    AppLoader,
  },
  computed: {
    offers() {
      return this.$store.get('instantSavings/offers');
    },
  },
  created() {
    const { encodedOrderUuid } = this.$route.params;
    if (!encodedOrderUuid) {
      this.$router.replace({ name: 'disclaimer' });
      this.$store.commit('DISABLE_LOADER');
    }
  },
  async mounted() {
    const { encodedOrderUuid } = this.$route.params;
    await this.$store.dispatch('instantSavings/getToken');
    await this.$store.dispatch('instantSavings/decodeOrderUuid', encodedOrderUuid);
    await this.$store.dispatch('instantSavings/getReturnToSiteOffers');
  },
  methods: {
    getTemplate(schemaName) {
      const tileComponentMappings = {
        'MGO Advantage Mobile Full Page Default': 'AdvantageMobileDefault',
        'MGO Advantage Mobile Full Page Expanded': 'AdvantageMobileExpanded',
      };
      return tileComponentMappings[schemaName];
    },
  },
};
</script>
